
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-photo-holiday-cards",
      function () {
        return require("private-next-pages/custom-photo-holiday-cards/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-photo-holiday-cards"])
      });
    }
  